import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUserService } from '../current-user.service';
import { ErrorVTO } from '../auth-service.model';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../auth-service';
import { environment } from '../../../environments/environment';
import { CustomerProductVTO } from '../../pages/user-dashboard/user-product-details/user-product-details.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerProductService {
  private router = inject(Router);
  private currentUserService = inject(CurrentUserService);
  private authService = inject(AuthService);
  private API = signal(environment.productsApiUrl);
  private http = inject(HttpClient);
  private getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }

  getCustomerProductById(productId: string, storeId?: number | null): Observable<CustomerProductVTO> {
    let headers = this.getHeaders();
    if (storeId != null) headers = headers.set('Store-Id', storeId.toString());
    return this.http.get<CustomerProductVTO>(`${this.API()}/customer/products/${productId}`, { headers });
  }

  private handleError = (error: HttpErrorResponse) => {
    if (error.status === 403) {
      this.router.navigate(['/login']);
      this.currentUserService.logout();
    }
    const apiError: ErrorVTO = error.error;
    return throwError(() => apiError);
  };
}
